const amountMenuNavSidebar = ($anchorScroll, $location) => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: {
      components: "@",
    },
    link: (scope, element) => {
      scope.convertToWrapperId = (str) => {
        const snakeCased = str.toLowerCase().replace(/\s/g, "_");
        return `${snakeCased}_wrapper`;
      };
      scope.scrollTo = (component) => {
        const id = scope.componentIds[component];
        $location.hash(id);
        $anchorScroll();
      }
      scope.openNavBar = () => {
        element.find("#nav-bar-pane").addClass("open");
      };
      scope.closeNavBar = () => {
        element.find("#nav-bar-pane").removeClass("open");
      };

      scope.componentsObj = JSON.parse(scope.components)
      scope.sections = Object.keys(scope.componentsObj)
      scope.componentIds = {};

      angular.forEach(scope.componentsObj, (componentArr, section) => {
        angular.forEach(componentArr, (component) => {
          scope.componentIds[component] = scope.convertToWrapperId(component);
        })
      });
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountMenuNavSidebar", ["$anchorScroll", "$location", amountMenuNavSidebar]);
